import { render, staticRenderFns } from "./BulkChangeApplicationsStatus.vue?vue&type=template&id=7cd3a5ec&"
import script from "./BulkChangeApplicationsStatus.vue?vue&type=script&lang=js&"
export * from "./BulkChangeApplicationsStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports